import { render, staticRenderFns } from "./ApprovalGuidance.vue?vue&type=template&id=c6db9b90&scoped=true&"
import script from "./ApprovalGuidance.vue?vue&type=script&lang=js&"
export * from "./ApprovalGuidance.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalGuidance.vue?vue&type=style&index=0&id=c6db9b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6db9b90",
  null
  
)

export default component.exports